/**
 * Component to show result count for a table
 * For eg: Showing 1-15 out of 200
 *
 * Handles loading and no result found as well
 *
 */

import { Text } from '@chakra-ui/react';
import { strings } from 'config/localization';
import React from 'react';

export interface ResultCountDisplayProps {
  isLoading: boolean;
  totalCount: number | undefined; // total number of items
  resultCount: number; // number of items present in a page
  pageSize: number;
  currentPage: number;
}

const ResultCountDisplay: React.FC<ResultCountDisplayProps> = (props) => {
  const { isLoading, totalCount, resultCount, pageSize, currentPage } = props;
  const lowerCount = pageSize * (currentPage - 1) + 1;
  const upperCount = pageSize * (currentPage - 1) + resultCount;

  return (
    <Text as="span">
      {isLoading && `${strings.loading}...`}
      {!isLoading && resultCount > 0 && (
        <>
          {strings.showing} {lowerCount} - {upperCount} {strings.out_of}{' '}
          {totalCount}
        </>
      )}
      {!isLoading && resultCount < 1 && strings.no_result_found}
    </Text>
  );
};

export default ResultCountDisplay;
